var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.connected
    ? _c("div", { staticClass: "connected" }, [
        _vm._v("\n    Vous êtes maintenant connecté ! \n  "),
        _vm.analysts && _vm.analysts.length
          ? _c(
              "p",
              {
                staticClass: "connect-warning",
                staticStyle: {
                  color: "#f3af48",
                  "margin-top": "25px",
                  "font-size": "1rem",
                },
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t("dash.bots.analysts") + " " + _vm.analysts.join(", ")
                  )
                ),
              ]
            )
          : _vm._e(),
      ])
    : _vm.page && _vm.twoFactor
    ? _c(
        "div",
        { ref: "wrapper" },
        [
          _c("page-image-avatar", {
            staticClass: "avatar",
            attrs: { page: _vm.page },
          }),
          _c("p", { staticClass: "name" }, [_vm._v(_vm._s(_vm.page.name))]),
          _c("div", { staticClass: "description" }, [
            _vm.twoFactor.verification_method == 0
              ? _c("p", [
                  _vm._v(
                    "\n            Veuillez renseinger ci-dessous le code de verification recu sur l'application \n            vous permettant d'effectuer vos authentifications à deux facteurs et cliquez sur le bouton ci-dessous :\n        "
                  ),
                ])
              : _vm._e(),
            _vm.twoFactor.verification_method == 1
              ? _c("p", [
                  _vm._v(
                    "\n            Veuillez renseinger ci-dessous le code de verification recu par SMS et cliquez sur le bouton ci-dessous :\n        "
                  ),
                ])
              : _vm._e(),
            _vm.twoFactor.verification_method == 4
              ? _c("p", [
                  _vm._v(
                    "\n            Veuillez accepter l'appareil " +
                      _vm._s(_vm.page.story_config.user_agent.split(";")[4]) +
                      " depuis la notification envoyée \n            par votre application Instagram et cliquez sur le bouton ci-dessous :\n        "
                  ),
                ])
              : _vm._e(),
            _vm.twoFactor.verification_method == 90
              ? _c("p", [
                  _vm._v(
                    "\n            Veuillez entrer le code recu par Email ou SMS puis cliquez sur le bouton ci-dessous :\n            (Cette methode de verification est une nouvelle route en cours de test et peut rencontrer des difficultés à se connecter)\n        "
                  ),
                ])
              : _vm._e(),
            _vm.twoFactor.verification_method == 99
              ? _c("p", [
                  _vm._v(
                    "\n            Veuillez accepter l'appareil " +
                      _vm._s(_vm.page.story_config.user_agent.split(";")[4]) +
                      " depuis la notification envoyée \n            par votre application Instagram ou entrer le code recu par SMS puis cliquez sur le bouton ci-dessous :\n            (Si vous etes dans le cas d'une notification, laissez le champs ci-dessous vide)\n        "
                  ),
                ])
              : _vm._e(),
            _vm.twoFactor.verification_method == 98
              ? _c("p", [
                  _vm._v(
                    "\n            Veuillez  entrer le code recu par Email ou SMS puis cliquez sur le bouton ci-dessous :\n        "
                  ),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "interract" }, [
            _vm.twoFactor.verification_method != 4
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.code,
                      expression: "code",
                    },
                  ],
                  staticClass: "code",
                  attrs: { type: "number" },
                  domProps: { value: _vm.code },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.code = $event.target.value
                    },
                  },
                })
              : _vm._e(),
            _c(
              "button",
              {
                ref: "connect-btn",
                staticClass: "connect-btn",
                attrs: {
                  disabled: _vm.twoFactor.verification_method != 4 && !_vm.code,
                },
                on: { click: _vm.connectApi },
              },
              [_vm._v("Connecter")]
            ),
            _vm.twoFactor.verification_method == 98
              ? _c("div", [
                  _c("p", [_vm._v(_vm._s(_vm.$t("dash.pages.linkedin_code")))]),
                  _c(
                    "button",
                    {
                      staticClass: "connect-btn",
                      on: { click: _vm.resendCode },
                    },
                    [_vm._v(_vm._s(_vm.$t("dash.pages.linkedin_code_btn")))]
                  ),
                ])
              : _vm._e(),
          ]),
          _vm.error_response
            ? _c("p", { staticClass: "error-return" }, [
                _vm._v(_vm._s(_vm.error_response)),
              ])
            : _vm._e(),
          _vm.info_response
            ? _c("p", { staticClass: "info-return" }, [
                _vm._v(_vm._s(_vm.info_response)),
              ])
            : _vm._e(),
        ],
        1
      )
    : _c("div", { ref: "wrapper", staticClass: "description" }, [
        _vm._v(
          "\n    Erreur la page n'existe pas ou n'a pas besoin d'authentifiacation à deux facteurs.\n"
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }